<template>
    <div class="flex flex-col px-8">
        <div v-if="isLoading" class="h-full flex flex-col justify-center items-center">
            <base-spinner></base-spinner>
        </div>
        <div v-else-if="!isLoading && !hasItems" class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium py-16">No students found!</h1>
        </div>
        <div v-else class="flex flex-col">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Start Date & Time</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">End Date & Time</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-2 font-medium">{{ paginatorInfo.firstItem + index }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <img class="h-12 w-12 rounded-lg object-cover cursor-pointer" :src="getProfilePicture(item.user.students.student_id, item.user.students.entity, item.user.profile_picture_url)" alt="">
                                            </div>
                                            <div class="flex-grow flex flex-col mr-4">
                                                <h1 class="text-sm font-semibold flex items-center">
                                                    <span class="text-heading">{{ item.user.name }}</span>
                                                </h1>
                                                <p class="text-xs text-gray-400">{{ item.user.email }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ getInterviewDateTime(item.start_date_and_time) }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ getInterviewDateTime(item.end_date_and_time) }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.user.students.student_id }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.user.students.entity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <pagination
                :paginatorInfo="paginatorInfo"
                :setPage="setPage"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import Pagination from "../../../components/shared/pagination.vue";
import { formattedDateWithTimeAmPm } from "../../../helpers/utils";
export default {
    name: 'interview-candidates',
    props: ["interviewId"],
    components: {
        Pagination,
    },
    data() {
        return {
            isLoading: false,
            error: null,
            first: 10,
            page: 1,
            hasItems: false,
            items: [],
            paginatorInfo: [],
        };
    },
    created() {
        this.fetchStudentsList();
    },
    methods: {
        async fetchStudentsList() {
            
            this.isLoading = true;

            const GET_INTERVIEW_CANDIDATES_QUERY = gql`
                query GetCandidatesListPerInterview($first: Int!, $page: Int!, $interview_id: Int!) {
                    getCandidatesListPerInterview(first: $first, page: $page, interview_id: $interview_id) {
                        error
                        error_code
                        message
                        data {
                            start_date_and_time
                            end_date_and_time
                            user {
                                id
                                name
                                email
                                profile_picture_url
                                students {
                                    student_id
                                    entity
                                }
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }
            `;

            try {
                await this.$apollo.query({
                    query: GET_INTERVIEW_CANDIDATES_QUERY,
                    fetchPolicy: 'network-only',
                    variables: {
                        first: this.first,
                        page: this.page,
                        interview_id: parseInt(this.interviewId),
                    },
                }).then((data) => {
                    if (data.data.getCandidatesListPerInterview.error) {
                        this.error = data.data.getCandidatesListPerInterview.message;
                    } else {
                        this.items = data.data.getCandidatesListPerInterview.data;
                        this.paginatorInfo = data.data.getCandidatesListPerInterview.paginatorInfo;
                        this.hasItems = this.items.length > 0 ? true : false;
                    }
                }).catch((error) => {
                    this.error = error.message;
                })

            } catch (error) {
                this.error = error.message || "Please try again.";
            }

            this.isLoading = false;

        },
        getProfilePicture(studentId, entity, profilePictureUrl) {
            if (profilePictureUrl == '/storage/alumni-profile-pictures/default-avatar.jpg') {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
            }
        },
        setPage(page) {
            this.page = page;
            this.fetchStudentsList();
        },
        getInterviewDateTime(date) {
            if (date) {
                return formattedDateWithTimeAmPm(date);
            } else {
                return "";
            }
        },
    },
}
</script>